/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c75712994f6f10547115c96cb84c098>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "ImageFullscreen".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for viewing an image in a fullscreen view or modal.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const ImageFullscreenIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "ImageFullscreenIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 1.5H5V0H1.375C.615 0 0 .616 0 1.375V5h1.5zM3 5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h.633l2.892-3.719a1.375 1.375 0 0 1 1.927-.244l1.048.81V5a.5.5 0 0 0-.5-.5zm6.5 5.743L9.633 8.801l-2.1 2.699H11a.5.5 0 0 0 .5-.5zM16 11v3.625c0 .76-.616 1.375-1.375 1.375H11v-1.5h3.5V11z" clip-rule="evenodd"/><path fill="currentcolor" d="M7.5 6.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
ImageFullscreenIcon.displayName = 'ImageFullscreenIcon';
var _default = exports.default = ImageFullscreenIcon;